module.exports = __webpack_public_path__ + "static/img/01-banner.12c80f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-tzzM/01-banner.jpg
// module id = OcIQ
// module chunks = 1